/* eslint-disable gatsby/use-gatsby-link */

import React from 'react';
import { useIntl } from 'react-intl';

import { Launch, Forum } from '@carbon/icons-react';
import { Telegram } from 'components';

import { external } from 'data/links';
import * as css from './Links.module.scss';

export default function Links() {
    const { formatMessage } = useIntl();

    return (
        <section className={css.root}>
            <a className={css.link} href={external.telegram} target="_blank" rel="noreferrer noopener">
                <span className={css.title} children={formatMessage({ defaultMessage: 'View our Telegram group' })} />
                <Telegram className={css.icon} size={24} />
            </a>

            <a className={css.link} href={external.support} target="_blank" rel="noreferrer noopener">
                <span className={css.title} children={formatMessage({ defaultMessage: 'Contact Support' })} />
                <Forum className={css.icon} size={24} />
            </a>

            <a className={css.link} href={external.braiins} target="_blank" rel="noreferrer noopener">
                <span className={css.title} children={formatMessage({ defaultMessage: 'View Braiins.com' })} />
                <Launch className={css.icon} size={24} />
            </a>
        </section>
    );
}
